export default {
  name: 'お役立ちサービス・条件',
  children: [
    { label: '手ぶらキャンプ・レンタル', value: 'service_rental' },
    { label: 'ペット同伴', value: 'service_pet' },
    { label: '温水・給湯付き炊事場', value: 'service_hotwater' },
    { label: '洋式トイレ', value: 'service_washlet' },
    { label: '現地ゴミ捨て', value: 'service_garbage' },
    { label: 'Wi-Fi・無線LAN', value: 'service_wifi' },
    { label: '薪販売', value: 'service_firewood' },
    { label: '直火 可', value: 'service_openfire' },
    { label: '花火 可', value: 'service_firework' },
    { label: '団体貸切', value: 'service_group' },
    { label: '無料キャンプ場', value: 'service_freecharge' },
  ],
};
